var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-view"},[(_vm.loaded)?_c('HubCalendar',{attrs:{"name":'calendar',"show-detail":_vm.showDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }